import showToast from "constants/showToast";
import { create } from "zustand";
import { persist } from "zustand/middleware";

const initialState = [];

export const useCartStore = create(
  persist(
    (set, get) => ({
      cart: [],
      addToCart: (item) =>
        set((state) => ({
          cart: [...addItemToCart(state.cart, item)],
        })),
      removeFromCart: (id) =>
        set((state) => ({
          cart: [...state.cart.filter((item) => item.id !== id)],
        })),
      reset: () => set(initialState),
    }),
    {
      name: "cartStore",
      //   storage: createJSONStorage(() => SecureStorage),
    }
  )
);

function addItemToCart(cart, item) {
  if (cart?.length > 0) {
    const itemInCart = cart?.filter((cartItem) => cartItem.id === item.id)[0];
    if (itemInCart) {
      showToast("Item has already been added to cart", "warn");
      return cart;
    }
  }
  let newArray = [];

  newArray = [...cart, item];
  showToast("Item added to cart successfully", "success");

  return newArray;
}

export function useCartSumTotal() {
  const cart = useCartStore((state) => state.cart);
  let sum = 0;
  cart?.forEach((item) => (sum += Number(item.price)));

  return sum;
}

export default useCartStore;
